<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('marketing.salesTools') }}</span>
        <h3 class="page-title">{{ $t('marketing.segments') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button theme="success" @click.prevent="$router.push('/funkcje-sprzedazowe/segmenty/nowy')">
          <i class="material-icons">add</i>
          {{ $t('marketing.addNewSegment') }}
        </d-button>
      </d-col>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">{{ $t('ui.name') }}</th>
            <th scope="col" class="border-0 text-center">{{ $t('marketing.listGenerationDate') }}</th>
            <th scope="col" class="border-0 text-right">{{ $t('marketing.maxCustomersTable') }}</th>
            <th scope="col" class="border-0 text-right">{{ $t('marketing.filtersCount') }}</th>
            <th scope="col" class="border-0 text-center" width="125">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(segment, index) of segments"
            :key="'segment-' + index">
            <td class="align-middle">
              {{ segment.name }}
            </td>
            <td class="align-middle text-center">
              {{ formatDate(segment.list_generated_at) }}
            </td>
            <td class="align-middle text-right">
              {{ segment.customers_limit }}
            </td>
            <td class="align-middle text-right">
              {{ segment.filters_count }}
            </td>
            <td class="align-middle text-center">
              <d-button
                theme="primary"
                @click.native="$router.push('/funkcje-sprzedazowe/segmenty/edycja/' + segment.id)"
                class="mr-2"
                :title="$t('ui.edit')">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                :disabled="removeInProgress"
                @click.native="removeSegment(segment.id)"
                :title="$t('ui.delete')">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="segments.length === 0">
            <td
              colspan="5"
              class="text-center">
              {{ $t('marketing.noSegmentsToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="!loaded"
        class="pb-3 pt-3 text-center">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-card>
  </d-container>
</template>

<script>
import ListUtils from '@/utils/ListUtils.js';
import CalendarUtils from '@/utils/CalendarUtils';

export default {
  name: 'marketing-segments',
  data() {
    return {
      segments: [],
      loaded: false,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      ListUtils.loadItemsData(this, '/marketing/segments/items', 'segments', {}, 'get');
    },
    formatDate (date) {
      if (!date) {
        return '-'
      }

      return CalendarUtils.humanDateFormat(this.dayData.date, false, false);
    },
    removeSegment (countryID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/marketing/segments/delete/',
        id: countryID,
        successTitle: this.$t('marketing.removeSegmentSuccessTitle'),
        successText: this.$t('marketing.removeSegmentSuccessText'),
        confirmTitle: this.$t('marketing.removeSegmentConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('marketing.removeSegmentErrorText'),
        successAction: () => {
          this.removeInProgress = false;
          this.loadData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

